import React from 'react'
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const ContactUs = () => {
  const { content } = useContentfulContext();

  return (
    <section>
      <div className="mx-auto flex flex-col md:flex-row items-center max-w-[75%] my-12">
        <div className="p-8 lg:w-1/2">
          <div className="">
            <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl text-left">{content.CONTACT_US_CONTENT?.hero_section.title}</h1>
            <img src={content.CONTACT_US_CONTENT?.hero_section.image_url} alt="" className='w-40 my-8'/>
            <div className='my-4'>
              {content.CONTACT_US_CONTENT?.hero_section.description.map((item) => {
                return <div className='mb-4'>
                  <h4 className="text-xl font-bold">{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              })}
            </div>
          </div>
        </div>
        <div className="p-8 flex flex-col lg:w-1/2 justify-center items-start">
          <div className="space-y-4 md:space-y-6 w-full">
            <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl text-center">Contact Us</h1>
            <div className="block max-w-full p-6 bg-white border border-gray-200 rounded-lg shadow text-center">
              <p className="mb-4">Please explain your query in the email at <a href="mailto:hello@dazetta.co" className="text-primary hover:underline">hello@dazetta.co</a> - we will come back to your as soon as possible.</p>
              <a className="inline-block px-5 py-3 text-white text-center tracking-tight bg-primary hover:bg-indigo-600 rounded-lg focus:ring-4 focus:ring-indigo-300 transition duration-200" href="mailto:hello@dazetta.co">Send us email</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactUs;